export default __webpack_public_path__ + "bf0a9dd613f1ca8e60320fd08e14c293.twig";